<div class="addResourceTag">
    <div class="content">
        <app-object-creator [data]="jsonCreatorData"></app-object-creator>
    </div>
    <div class="button-container">
        <app-button-generator [buttonGenInput]="buttonInput">
        </app-button-generator>
    </div>
</div>
